import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-brand-cream font-sans text-brand-choco selection:bg-brand-pink selection:text-white" data-id="element-0" data-mp="33oriy2lrxzq1">
      <noscript data-id="element-1" data-mp="3dkl4ucldv5kh">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3dl4lzr37lpxg" />
      </noscript>

      <Hero data-id="element-3" data-mp="stc8k5naf2of" />
      <main data-id="element-4" data-mp="st2kinlsz5ld">
        <ProblemSection data-id="element-5" data-mp="swqcvjfihlyi" />
        <SolutionSection data-id="element-6" data-mp="36859fxwiety" />
        <BonusesSection data-id="element-7" data-mp="35ovimiemwr0" />
        <BenefitsSection data-id="element-8" data-mp="34x31kk3tf4y" />
        <OfferSection data-id="element-9" data-mp="38b50rouvmbv" />
        <GuaranteeSection data-id="element-10" data-mp="3ud1e95yxri91" />
        <Testimonials data-id="element-11" data-mp="3ubri4mbn8k51" />
        <FAQSection data-id="element-12" data-mp="3ucjcxuxf2du9" />
        <FinalCTA data-id="element-13" data-mp="3uf5gzkl3mb7q" />
      </main>
      <Footer data-id="element-14" data-mp="d57dixer88gf" />
      {showPurchasePopup && <PurchasePopup data-id="element-15" data-mp="d45ua5nl4fnm" />}
    </div>;
}